import React, { useState, useEffect } from "react";
import Phone from "../3D-Phone/Phone";
import Ipad from "../3D-ipad/Ipad";
import "./Contact.css";
import ContactForm from "../../contents/ContactForm/ContactForm";
import { ContactInfo } from "../../contents/ContactInfo/ContactInfo";

const Contact = ({ theme }) => {
  return (
    <section className="contact" id="contact">
      <div className="contact-content section-content">
        <p className="section-subtitle">Contact</p>
        <h2 className="h3 section-title">
          Have You Any Ideas? Please Drop a Message
        </h2>
        <p className="section-text">
          Get in touch and let me know how I can help. Fill out the form and
          I’ll be in touch as soon as possible.
        </p>

        {/* <ContactInfo /> */}
        {/* <Ipad /> <Phone /> */}
        {theme === "light_theme" ? <Phone /> : <Ipad theme={theme} />}

      </div>

      <div className="cform">
        <ContactForm />
      </div>
    </section>
  );
};

export default Contact;
